import type { PublicationItem } from "../../data/site";
import { Card } from "../ui/Card";
import "./publications.css";

function doiToUrl(doi?: string) {
  if (!doi) return undefined;
  return `https://doi.org/${doi}`;
}

export function Publications({ items }: { items: PublicationItem[] }) {
  return (
    <div className="pub">
      {items.map((p) => {
        const doiUrl = doiToUrl(p.doi);
        return (
          <Card key={`${p.title}-${p.date}`}>
            <div className="pub__top">
              <div className="pub__title">{p.title}</div>
              <div className="pub__date">{p.date}</div>
            </div>

            <div className="pub__meta">
              <span className="pub__venue">{p.venue}</span>
              <span className="dot" aria-hidden>
                ·
              </span>
              <span className="pub__role">{p.role}</span>
              {p.levelHint ? (
                <>
                  <span className="dot" aria-hidden>
                    ·
                  </span>
                  <span className="pub__level">{p.levelHint}</span>
                </>
              ) : null}
              {p.status ? (
                <>
                  <span className="dot" aria-hidden>
                    ·
                  </span>
                  <span className="pub__status">{p.status}</span>
                </>
              ) : null}
            </div>

            {doiUrl ? (
              <div className="pub__links">
                <a className="plink" href={doiUrl} target="_blank" rel="noreferrer">
                  <span className="plink__label">DOI</span>
                  <span className="plink__icon" aria-hidden>
                    ↗
                  </span>
                </a>
              </div>
            ) : null}
          </Card>
        );
      })}
    </div>
  );
}

